import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

export default function SearchBanner() {
    const { query } = useAppState();
    
    return ((query?.query && query.query !== '') && (
        <div className="ns-search-bannner lg:flex relative">
            <div className="w-full py-8 lg:py-10 px-5 lg:px-0 text-center lg:flex lg:flex-col lg:items-center lg:justify-center">
                <div className="lg:hidden">
                    <nav className="body-2" role="navigation" aria-label="breadcrumbs">
                        <ol className="flex md:pt-[0.938rem] md:pb-[0.313rem] justify-center md:justify-start pt-[1.875rem] pb-2.5 !px-5 !py-0 mb-2 !justify-center !items-center">
                            <li><a className="no-underline" href="/">Home</a></li>
                            <li><span className="mx-2">/</span></li>
                            <li>Search results for "{query.query}"</li>
                        </ol>
                    </nav>
                </div>
                <h2 className="mb-2 lg:mb-2.5 max-w-[300px] mx-auto">Search results for "{query.query}"</h2>
            </div>
        </div>
    ))
}
